// react imports
import React, { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// CUSTOM COMPONENTS
import AppContext from "../AppContext";
import GoogleMaps from "../components/GoogleMaps/GoogleMaps";

import { MDBContainer } from "mdb-react-ui-kit";

const KapcsolatPage = (props) => {
  const context = useContext(AppContext);
  let [searchParams] = useSearchParams();

  useEffect(() => {}, []);

  return (
    <MDBContainer>
      <div className="elerhetoseg">
        <h4 className="title">Elérhetőség</h4>
        <span className="description">A tó Tata és Agostyán között helyezkedik el.</span>
        <span className="description">
          Budapest felől az M1-es autópályán, Győr felé haladva kell lekanyarodni Tatánál.
        </span>
        <span className="description">
          A belvárosban a körforgalomnál Agostyán felé kijutunk a városból, ahonnan 2 km-re található a tó.
        </span>
        <span className="description">A tóhoz aszfaltozott út vezet.</span>
      </div>
      <div style={{ width: "100%" }}>
        <GoogleMaps />
      </div>
      <div className="kapcsolat">
        <span>Foglalás és információ a következő számon kérhető: +36307494358</span>
      </div>
    </MDBContainer>
  );
};

export default KapcsolatPage;
